import styles from "./ModalSuccess.module.css";
import { useModal } from "../../hooks/useModalHook";

const ModalSuccess = () => {
  const { closeModal } = useModal();
  return (
    <div className={styles.modalInfo}>
      <h3 className={styles.titleModal}>Ваша заявка успешно отправлена!</h3>
      <div className={styles.descriptionModal}>
        Наш администратор свяжется с&nbsp;вами и&nbsp;запишет на&nbsp;удобное
        вам время.
        <br />
        <br />
        Будем очень рады Вашему визиту!
      </div>
      <button onClick={closeModal} className={styles.buttonModal}>
        Понятно
      </button>
    </div>
  );
};

export default ModalSuccess;
